import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null,
    isAuthenticated: false,
    nickname: null,
    token: null,
  }),
  actions: {
    setUser(userData) {
      this.user = userData;
      this.nickname = userData.nickname;
      this.token = userData.token;
      this.isAuthenticated = true;
    },
    logout() {
      this.user = null;
      this.nickname = null;
      this.token = null;
      this.isAuthenticated = false;
      
      // Limpiar localStorage
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('userNickname');
      localStorage.removeItem('userId');
    },
    checkAuth() {
      const token = localStorage.getItem('authToken');
      const nickname = localStorage.getItem('userNickname');
      
      if (token && nickname) {
        this.setUser({ nickname, token });
        return true;
      } else {
        this.logout();
        return false;
      }
    },
    initializeAuth() {
      return this.checkAuth();
    }
  },
  getters: {
    isLoggedIn: (state) => state.isAuthenticated,
    currentUser: (state) => state.user,
    userNickname: (state) => state.nickname,
    authToken: (state) => state.token,
  },
});